import React from "react";
import { WizTableForm } from '@/containers/common'
import { mergeColumns } from '../../utils';

const organization = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

//配置项
const componentName = "certReport";

function columns() {
  const columns = [
    {
      title: "证书分类",
      name: "categoryId",
      dict: {
        wizReplaceData: "certCategoryNodeList"
      },
      searchItem: {
        type: 'treeselect',
        dropdownStyle: {
          maxHeight: '400px'
        },
        rules: [
          {
            required: true,
            message: '请选择证书分类'
          }
        ],
      }
    },
    {
      title: "证书分类",
      name: "categoryName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      }
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
  ];

  return mergeColumns.call(this, columns,[])
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListOrg`,
    payload: {
      key: `${componentName}@getPageListOrg`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportOrg`,
    payload: {
      key: `${componentName}@exportOrg`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `organizationNodeCategory@getTypeNodeList`,
      apiParams: {}
    }
  },
  certCategoryNodeList: {
    path: `contentLabel/nodeList`,
    payload: {
      key: `contentLabel@nodeList`,
      apiParams: { state: 1, type: 13 }
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree", "certCategoryNodeList"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
